import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialities',
  templateUrl: './specialities.component.html',
  styleUrls: ['./specialities.component.css']
})
export class SpecialitiesComponent implements OnInit {
  public list: any;
  constructor() {
    this.list = [
      {
        icon: 'ion-ios-monitor-outline',
        title: 'Interactive Dashboard',
        description: 'Dashboards provides quick insights to professors in the student reviews'
      },
      {
        icon: 'ion-asterisk',
        title: 'AI Automation',
        description: 'Our AI provides automated workflow and smart moderation of reviews and comments for optimal efficiency..'
      },
      {
        icon: 'ion-clipboard',
        title: 'Reports',
        description: 'Our software can aggregate and generate detailed reports for annual/semi-annual auditing purposes'
      },
      {
        icon: 'ion-ios-settings',
        title: 'Full-control',
        description: 'Admin have the full power to set the custom policies, parameters and rule-based alerts.'
      },
    
      {
        icon: 'ion-ios-world-outline',
        title: 'Web Branding',
        description: 'A user can create a quick HTML iframe of professor reports and student progress to share on a University’s website.'
      },
      {
        icon: 'ion-ios-chatboxes',
        title: 'Real-Time Recommendations',
        description: 'Get recommendations from AI to professors and students for improving the student experience.'
      },
      {
        icon: 'ion-ios-checkmark-outline',
        title: 'Best User Experience',
        description: 'With our superb UI, you can expect an exceptional user experience for students, professors and university admins'
      },
      {
        icon: 'ion-iphone',
        title: 'Mobile App',
        description: 'Easy access through our convenient mobile app so students can regularly review professors'
      }
    ];
  }

  ngOnInit() {
  }

}
